import { Stack, Typography } from '@mui/material';

import { useSessionsStore } from 'kerberus-components/src/Components/Backend/sessionsStore';

export default function SessionInfo() {
    const sessions = useSessionsStore((state) => state.sessions);

    const all = sessions?.all.length;
    const arp = sessions?.arp.length;
    const headless = sessions?.headless.length;

    const fontSize = { sm: 16, xs: 12 };

    return (
        <Stack
            direction="row"
            spacing={{ sm: 2, xs: 1 }}
            sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                borderRadius: '4px',
                display: { lg: 'flex', xs: 'none' },
                position: 'absolute',
                px: { sm: 1, xs: 0.5 },
                right: { sm: 5, xs: 2 },
                top: { sm: -3, xs: -2 },
            }}
        >
            <Typography sx={{ fontSize }}>All: {all}</Typography>
            <Typography sx={{ fontSize }}>Arp: {arp}</Typography>
            <Typography sx={{ fontSize }}>HL: {headless}</Typography>
        </Stack>
    );
}
